import { useMutation, useQueryClient } from "@tanstack/react-query";
import { checkForExistingUser, hasTakenTrial } from "../UpsellPanelService";

export const useCheckExistingUserMutation = () => {
    return useMutation({
        mutationFn: async (email) => await checkForExistingUser(email)
    });
}

export const useHasTakenTrialMutation = (handleSuccess, handleError) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (requiredAccessLevel) => 
            await hasTakenTrial(requiredAccessLevel),
        onSuccess: (data, cacheKey) => {
            queryClient.setQueryData(['hasTakenTrial', cacheKey], data);
            if (handleSuccess) {
                handleSuccess(data);
            }
        },
        onError: handleError,
    });
};
